import {
  create_title
} from '@/base/titleData'
import pageData from '@/base/pageData'
import {
  basic_download_new_style
} from '@/base/widgets_data_compatible';

export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  mb_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  pc_widgets_infor: {
    font: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal'
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal'
      }
    },
    title: create_title('File download'),
    page: pageData
  },
  mb_widgets_infor: {
    title: create_title('File download'),
  },
  listArr: {
    moduleStyle: 0,
    fileList: [],
    ...basic_download_new_style()
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_download/style.js